import React from 'react';
import { ShieldCheck, Lock, Mail, MessageCircle } from 'lucide-react';
export function Guarantee() {
  return <section className="py-7 md:py-10 px-4 bg-brand-dark border-y border-brand-accent/10" data-id="element-94">
      <div className="max-w-2xl mx-auto text-center" data-id="element-95">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-brand-accent rounded-full mb-5 shadow-[0_0_30px_rgba(34,197,94,0.6)]" data-id="element-96">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-brand-dark" data-id="element-97" />
        </div>

        <h2 className="text-xl md:text-3xl font-black mb-4 text-brand-accent neon-glow uppercase tracking-tight" data-id="element-98">
          🛡️ GARANTÍA "AULA FELIZ" — 7 DÍAS
        </h2>

        <div className="text-sm md:text-base font-bold space-y-3 mb-5 text-gray-200 leading-relaxed" data-id="element-99">
          <p data-id="element-100">
            Abres los 6 tomos. Revisas los 4 bonos. Los usas en tu clase más
            difícil este lunes.
          </p>
          <p className="text-gray-400" data-id="element-101">
            Si el martes sientes que tus alumnos no participaron más, o que el
            material no te ahorró horas de trabajo:
          </p>
          <div className="py-2" data-id="element-102">
            <p className="text-xl md:text-2xl font-black text-brand-dark bg-brand-accent inline-block px-6 py-3 rounded-lg shadow-[0_0_20px_rgba(34,197,94,0.4)] uppercase tracking-wide" data-id="element-103">
              Te devolvemos el 100%
            </p>
          </div>
          <p className="text-gray-500 uppercase tracking-widest text-xs md:text-sm mt-2" data-id="element-104">
            Sin preguntas. Sin formularios. Sin dramas.
          </p>
        </div>

        <div className="bg-brand-card border border-brand-accent/30 rounded-lg p-4 md:p-5 text-left space-y-3 mb-5" data-id="element-105">
          <p className="text-sm md:text-base text-white font-bold leading-relaxed" data-id="element-106">
            Una persona real te va a responder.{' '}
            <span className="text-brand-accent" data-id="element-107">No un bot.</span> No un ticket
            automatizado. Una persona.
          </p>
          <p className="text-sm md:text-base text-brand-accent font-black italic leading-relaxed" data-id="element-108">
            Porque si el material no te sirve, no queremos tu dinero.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[10px] md:text-xs text-gray-300 font-black uppercase tracking-wide" data-id="element-109">
          <div className="flex items-center" data-id="element-110">
            <Lock className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-111" />
            <span data-id="element-112">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-113">
            <Mail className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-114" />
            <span data-id="element-115">Entrega inmediata por email</span>
          </div>
          <div className="flex items-center" data-id="element-116">
            <MessageCircle className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-117" />
            <span data-id="element-118">Soporte por WhatsApp</span>
          </div>
        </div>
      </div>
    </section>;
}